import request from "@/Rest";
import { LOCATION_URLS, ANALYTICS_URLS } from "@/Rest/api/urls";

export async function createLocationCode(location, userRole) {
  const payload = {
    location,
  };

  const role = userRole.toLowerCase();
  payload[role] = true;

  try {
    const { data } = await request.POST(
      LOCATION_URLS.createLocationCode,
      payload
    );

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function registrationEmail({
  email,
  code = "",
  role,
  dependents = 0,
}) {
  const payload = {
    email,
    code,
    role,
    dependents,
    is_white_label: true,
    brand_name: "we_train_your_brain", //This is the default project identifier for the user records in White label
  };
  try {
    const { data } = await request.POST(
      LOCATION_URLS.registrationEmail,
      payload
    );

    return data;
  } catch (error) {
    throw new Error(error.response.data);
  }
}

export async function locations() {
  try {
    const { data } = await request.GET(LOCATION_URLS.getLocations);

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function validateFacilityCode(facilityCode) {
  try {
    const payload = { facility_code: facilityCode };
    const { data } = await request.POST(
      LOCATION_URLS.validateFacilityCode,
      payload
    );
    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function locationPrices(facilityCode, locationName) {
  try {
    const params = {};

    if (facilityCode && locationName) {
      throw new Error(
        "Only one of facilityCode or locationName should be provided."
      );
    } else if (facilityCode) {
      params.facility_code = facilityCode;
    } else if (locationName) {
      params.location_name = locationName;
    } else {
      throw new Error(
        "At least one of facilityCode or locationName must be provided."
      );
    }

    const { data } = await request.GET(LOCATION_URLS.getLocationPrices, {
      params,
    });

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function getLocationUsers(page = 1, roles = [], location = null) {
  try {
    const rolesQuery = roles
      .map((role) => `roles=${encodeURIComponent(role)}`)
      .join("&");
    let url = `${LOCATION_URLS.getLocationUsers(page)}${
      rolesQuery ? `&${rolesQuery}` : ""
    }`;
    if (location) {
      url += `&location_name=${encodeURIComponent(location)}`;
    }
    const { data } = await request.GET(url);

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function numberSeats(params) {
  try {
    const { data } = await request.GET(LOCATION_URLS.getNumberSeats, {
      params,
    });

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function subtractSeat(location, quantity) {
  const payload = { location, quantity };
  try {
    const { data } = await request.POST(LOCATION_URLS.subtractSeat, payload);

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function plustSeats(location, quantity) {
  const payload = { location, quantity };
  try {
    const { data } = await request.POST(LOCATION_URLS.plustSeats, payload);

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function createLocation(formData) {
  try {
    const { data } = await request.POST(LOCATION_URLS.baseUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return { data, success: true };
  } catch (error) {
    return { success: false, data: error.response.data };
  }
}

export async function getUsers(page = 1) {
  try {
    const { data } = await request.GET(LOCATION_URLS.getUsers(page));

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function getTotalUsers(location) {
  try {
    const { data } = await request.GET(LOCATION_URLS.getTotalUsers(location));

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function getTotalSeats(location) {
  try {
    const { data } = await request.GET(LOCATION_URLS.getTotalSeats(location));

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function getTotalDelegates(location) {
  try {
    const { data } = await request.GET(
      LOCATION_URLS.getTotalDelegates(location)
    );

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function getTotalLocationAdmins() {
  try {
    const { data } = await request.GET(LOCATION_URLS.getTotalLocationAdmins);

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function getInvitations(page = 1, location = null) {
  try {
    const params = {};
    if (location) {
      params.location_name = location;
    }
    const { data } = await request.GET(LOCATION_URLS.getInvitations(page), {
      params,
    });

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function deleteInvitation(invitation) {
  try {
    const payload = {
      invitation,
    };
    const { data } = await request.DELETE(LOCATION_URLS.invitations, payload);

    return { data, success: true };
  } catch (error) {
    return { success: false };
  }
}

export async function getFreeTrial() {
  try {
    const { data } = await request.GET(LOCATION_URLS.getFreeTrial);

    return data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function getTotalTrainigSessions({ location, days = 7 }) {
  try {
    const { data } = await request.GET(
      LOCATION_URLS.getTotalTrainigSessions(location, days)
    );

    return data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function getTotalUsersPerSessions({ location, days = 7 }) {
  try {
    const { data } = await request.GET(
      LOCATION_URLS.getTotalUsersPerSessions(location, days)
    );

    return data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function getAnalyticsUserData(location, orderQuery, page = 1) {
  try {
    const orderQueryStr = orderQuery.join(",");
    const params = { location, order_by: orderQueryStr };
    const { data } = await request.GET(ANALYTICS_URLS.getUserData(page), {
      params,
    });

    return data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function getAnalyticsUserDataReport(recordIds, orderQuery) {
  try {
    const payload = { records_ids: recordIds, order_by: orderQuery };

    const { data } = await request.POST(
      ANALYTICS_URLS.getUserDataReport,
      payload,
      { responseType: "blob" }
    );

    return data;
  } catch (error) {
    throw new Error(error);
  }
}
